export const LOGIN_EVENT = "LOGIN_EVENT";
export const LOGIN_EVENT_TARGET = new EventTarget();
